import { html } from '@/helpers/html-template'
import type { ScalarGuideElement } from '@/types'
import { validate } from '@/helpers/validate'
import { nanoid } from 'nanoid'

import {
  type AttributesTab,
  type AttributesTabs,
  attributesTabsSchema,
} from './attributes'
import { EditorClasses } from '@/styles'
import { slugify } from '@/utilities'

export const scalarTab: ScalarGuideElement<AttributesTab, 'scalar-tab'> = {
  name: 'scalar-tab',
  tagName: 'scalar-tab',
  tiptapName: 'tabs',
  attributeTransform: (_, attrs) => {
    return {
      id: slugify(String(attrs.title ?? '')),
      title: String(attrs.title ?? ''),
    }
  },
  render: async (_) => {
    return html`
<div
  class="custom-container-content">
    <ssg-children />
</div>
    `
  },
}

export const scalarTabs: ScalarGuideElement<AttributesTabs, 'scalar-tabs'> = {
  name: 'scalar-tabs',
  tagName: 'scalar-tabs',
  tiptapName: 'tabs',
  attributeTransform: (_content, props: Partial<AttributesTabs>) => {
    const children = props.children ?? []
    const transformed = {
      children: children.map((child: any) => {
        return {
          id: child.id ?? child.dataId,
          title: child.title ?? child.dataTitle,
        }
      }),
      default: props.default,
    }
    return validate(attributesTabsSchema, transformed)
  },
  render: async (props: AttributesTabs) => {
    const { default: defaultTab, children } = props
    const defaultTabIndex = defaultTab
      ? Math.max(
          children.findIndex((child) => child.id === slugify(defaultTab)),
          0,
        )
      : 0
    const uid = nanoid()
    const tabGroupName = `custom-tabs-input-${uid}`

    const inputs = (children ?? [])
      .map((child, index) => {
        return html`
        <input
          id="custom-tabs-input-${child.id}"
          class="custom-tabs-input sr-only"
          name="${tabGroupName}"
          ${index === defaultTabIndex ? 'checked' : ''}
          type="radio"
          value="${index}" />
      `
      })
      .join('')
    const labels = props.children
      .map((child) => {
        return html`
        <label class="custom-tabs-tab" for="custom-tabs-input-${child.id}">${child.title}</label>
      `
      })
      .join('')

    const classNames = [EditorClasses.Tabs, 'custom-tabs-container']
    return html`
<div class="${classNames.join(' ')}">
  ${inputs}
  <div
    class="custom-tabs-navbar">
    <nav class="custom-tabs-nav">${labels}</nav>
  </div>
  <div class="custom-tabs-content"><ssg-children /></div>
</div>
`
  },
}
